import { useMemo } from 'react';
import isNil from 'lodash/isNil';
import { useQuery } from '@apollo/client';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { cachedCohortSelectorById } from '../../../../redux/selectors/builder';
import { addCachedCohort } from '../../../../redux/slices/oldBuilder';
import {
  ICohortFieldsFragment,
  INamedCohortQueryQuery,
  INamedCohortQueryQueryVariables,
} from '../../../../utils/apollo/graphqlSchema';
import { GET_NAMED_COHORT } from '../../../../utils/apollo/cohorts';

export default (cohortId: string) => {
  const dispatch = useAppDispatch();

  const cachedCohort = useAppSelector((state) =>
    cachedCohortSelectorById(state, cohortId),
  );

  const { loading, data } = useQuery<
    INamedCohortQueryQuery,
    INamedCohortQueryQueryVariables
  >(GET_NAMED_COHORT, {
    skip: !isNil(cachedCohort),
    variables: {
      id: cohortId,
    },
  });

  const cohort: ICohortFieldsFragment | null = useMemo(() => {
    if (!isNil(cachedCohort)) {
      return cachedCohort;
    }

    const namedCohort = data?.namedCohort;

    if (namedCohort) {
      dispatch(addCachedCohort({ cohort: namedCohort }));

      return namedCohort;
    }

    return null;
  }, [cachedCohort, data, dispatch]);

  return {
    loading,
    cohort,
  };
};
